/*
Markup:

<ul class="tabs tabs_interface_js" id="job-application-tabs">
    <li><a class="text-action" href="#tab-1">Job Overview</a></li>
    <li><a class="text-action" href="#tab-2">Application</a></li>
</ul>

<div class="tabs-content" data-tabs-content="job-application-tabs">
    <div id="tab-1" class="tab-panel"></div>
    <div id="tab-2" class="tab-panel"></div>
</div>

Style to your use case.
*/

/**
 * Builds tabs interface.
 *
 * @param {object} tabs The parent tabs ul element with id.
 * @returns void
 */
function tabs_interface(tabs) {
    if (!tabs) {
        return
    }

    tabs.forEach(function (tab_interface) {
        const tab_id = tab_interface.getAttribute('id')
        const tab_panel = document.querySelector(`[data-tabs-content=${tab_id}]`)

        if (!tab_panel) {
            return
        }

        tab_interface.setAttribute('role', 'tablist')
        tab_interface.querySelectorAll('li').forEach(li => li.setAttribute('role', 'presentation'))
        tab_interface.querySelectorAll('a').forEach((a, key) => {
            const href = a.getAttribute('href')
            const tab_id = '#' === href.charAt(0) ? href.substring(1) : href

            if (0 === key) {
                a.classList.add('is-active')
                a.setAttribute('tabindex', '0')
                a.setAttribute('aria-selected', 'true')
            } else {
                a.setAttribute('tabindex', '-1')
                a.setAttribute('aria-selected', 'false')
            }

            a.setAttribute('role', 'tab')
            a.setAttribute('aria-control', tab_id)
            a.setAttribute('id', `${tab_id}-label`)

            a.addEventListener('click', function (event) {
                set_tab_change_event(event, this, tab_interface, tab_panel)
            })

            a.addEventListener('keydown', function (event) {
                if (39 === event.keyCode) {
                    let next_tab

                    if (this.parentElement.nextElementSibling) {
                        next_tab = this.parentElement.nextElementSibling.querySelector('a')
                    } else {
                        next_tab = this.closest('.tabs').querySelector('a')
                    }

                    set_tab_change_event(event, next_tab, tab_interface, tab_panel)
                }

                if (37 === event.keyCode) {
                    let next_tab

                    if (this.parentElement.previousElementSibling) {
                        next_tab = this.parentElement.previousElementSibling.querySelector('a')
                    } else {
                        next_tab = [...this.closest('.tabs').querySelectorAll('a')].pop()
                    }

                    set_tab_change_event(event, next_tab, tab_interface, tab_panel)
                }
            })
        })

        tab_panel.querySelectorAll('.tab-panel').forEach((panel, key) => {
            if (0 === key) {
                panel.classList.add('is-active')
                panel.setAttribute('aria-hidden', 'false')
            } else {
                panel.setAttribute('aria-hidden', 'true')
            }

            const tab_panel_id = panel.getAttribute('id')

            panel.setAttribute('role', 'tabpanel')
            panel.setAttribute('aria-labelledby', `${tab_panel_id}-label`)
        })

        function set_tab_change_event(event, anchor, tab_interface, tab_panel) {
            event.preventDefault()

            anchor.focus()

            tab_interface.querySelectorAll('a').forEach(a => {
                a.setAttribute('tabindex', '-1')
                a.setAttribute('aria-selected', 'false')
                a.classList.remove('is-active')
            })

            const href = anchor.getAttribute('href')
            const tab_id = '#' === href.charAt(0) ? href.substring(1) : href

            anchor.classList.add('is-active')
            anchor.setAttribute('tabindex', '0')
            anchor.setAttribute('aria-selected', 'true')

            tab_panel.querySelectorAll('.tab-panel').forEach(panel => {
                panel.classList.remove('is-active')
                panel.setAttribute('aria-hidden', 'true')

                panel.querySelectorAll('iframe').forEach(iframe => {
                    if (!iframe || iframe.classList.contains('initialized')) {
                        return
                    }

                    // I removed the styles causing issue but in my experience
                    // iframes loaded in accordions and tabs need to be loaded
                    // in once the accordion/tab is activated or it might not
                    // have the state you expect it to have once active.

                    // I also tried visibility hidden and height 0 but the job
                    // applications iframe ended up with a very large height
                    // calculation.
                    iframe.src += ''
                    iframe.classList.add('initialized')
                })

                if (tab_id === panel.getAttribute('id')) {
                    panel.classList.add('is-active')
                    panel.setAttribute('aria-hidden', 'false')
                }
            })
        }
    })
}

document.addEventListener('DOMContentLoaded', tabs_interface(document.querySelectorAll('.tabs_interface_js')), false)
